import type { JobSchedule } from "@models/Schedule";
import { VStack, HStack, Text, Link } from "@chakra-ui/react";
import moment from "moment";
import { Link as RouterLink } from "react-router-dom";

interface Props {
	job: JobSchedule;
	competenceLabelByKey: Map<string, string>;
}

const JobSummaryList = ({ job, competenceLabelByKey }: Props) => {
	return (
		<VStack
			key={job.id}
			height={"100px"}
			width={"100%"}
			justify={"center"}
			alignItems={"flex-start"}
			px={3}
			gap={"1px"}
		>
			<HStack>
				<Text fontWeight={400} size={"14px"} m="0">{`${moment(job.startDate).format("DD/MM")} - ${moment(
					job.endDate,
				).format("DD/MM")}`}</Text>
				{job.status === "BOOKED" && (
					<Link
						as={RouterLink}
						to={`/uppdrag/${job.id}/tid?services=${competenceLabelByKey.get(job.competence.service)}`}
					>
						<Text
							m="0"
							cursor={"pointer"}
							_hover={{ textDecoration: "underline" }}
							color={"#219CD0"}
							fontSize={"14px"}
							fontWeight={500}
						>
							Förläng uppdrag
						</Text>
					</Link>
				)}
			</HStack>
			<Text fontWeight={700} size={"16px"} m="0" noOfLines={1}>
				{job.customer.name}
			</Text>
			<Link as={RouterLink} to={`/uppdrag/${job.id}`}>
				<Text
					m="0"
					cursor={"pointer"}
					_hover={{ textDecoration: "underline" }}
					color={"#999999"}
					fontSize={"16px"}
					fontWeight={400}
				>{`#${job.orderNumber}, ${competenceLabelByKey.get(job.competence.service)}`}</Text>
			</Link>
		</VStack>
	);
};

export default JobSummaryList;
